import { flexRender, Row } from "@tanstack/react-table";
import Button from "@weave-design/button";
import { PanelListElement, PanelType } from "../../../eventBus/panelListEventPayloads";
import eventBus from "../../../eventBus/eventDispatcher";
import "./panelListContent.css";

export const PanelListTableBodyRow = ({ row }: { row: Row<PanelListElement> }) => {
    const onPanelClick = () =>
        eventBus.dispatchEvent({
            type: "Dextall.PanelList.UI.PanelSelected",
            payload: {
                id: row.original.id,
                category: row.original.category,
            },
        });

    return (
        <tr
            key={row.id}
            className={`${row.original.type === PanelType.Atypical ? "panel-list-table__atypical-row" : ""}`}
        >
            {row.getVisibleCells().map(cell =>
                cell.column.id === "panelIdId" ? (
                    <td key={cell.id} className="panel-list-table__panelIdId-cell">
                        <Button
                            title={cell.getValue()}
                            type="secondary"
                            onClick={onPanelClick}
                            className="panel-list-table__panelIdId-button-visible"
                        />
                        {/* Second button is not visible and used only to get proper sizes of the cell */}
                        <Button
                            title={cell.getValue()}
                            type="secondary"
                            className="panel-list-table__panelIdId-button-invisible"
                        />
                    </td>
                ) : (
                    <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                ),
            )}
        </tr>
    );
};
